import { Input } from '@library/components/inputs';
import type { InputProps } from '@library/components/inputs';

export interface SearchProps extends InputProps {
  id: string;
  placeholder?: string;
  value: string;
  onValueChange: (value: string) => void;
}

export function Search({
  id,
  onValueChange,
  placeholder = 'Search',
  value,
  ...rest
}: SearchProps) {
  const handleOnChange = (searchInput = '') => {
    onValueChange(searchInput);
  };

  return (
    <Input
      type="search"
      id={id}
      onValueChange={handleOnChange}
      placeholder={placeholder}
      value={value}
      {...rest}
    />
  );
}
